import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";

import Player from '@/pages/Player.vue'
import ContentPlay from '@/components/ContentPlay.vue'
import { applySeo } from '@/utils/seo'


const routes:RouteRecordRaw[] = [

    { 
        path : "/", 
        redirect: "/Home"
    }

    //랜딩페이지
    , { 
        path: '/Home', 
        component: () => import('@/pages/Home/Home.vue'), 
        redirect: "/Home/InfoMain",
        children:[
          { path: 'InfoMain', component: () => import('@/pages/Home/InfoMain.vue')  },
          { path: 'InfoService', component: () => import('@/pages/Home/InfoService.vue')  },
          { path: 'InfoProject', component: () => import('@/pages/Home/InfoProject.vue')  },
          { path: 'InfoProduct', component: () => import('@/pages/Home/InfoProduct.vue')  },
          { path: 'InfoProgram', component: () => import('@/pages/Home/InfoProgram.vue')  },
          { path: 'InfoRef1', component: () => import('@/pages/Home/InfoRef1.vue')  },
          { path: 'InfoRef2', component: () => import('@/pages/Home/InfoRef2.vue') },
          { path: 'InfoRef3', component: () => import('@/pages/Home/InfoRef3.vue')  },
          { path: 'InfoRef4', component: () => import('@/pages/Home/InfoRef4.vue')  },
          { path: 'InfoRef5', component: () => import('@/pages/Home/InfoRef5.vue')  },
          { path: 'InfoRef6', component: () => import('@/pages/Home/InfoRef6.vue')  },
          { path: 'InfoRef7', component: () => import('@/pages/Home/InfoRef7.vue')  },
          { path: 'InfoRef8', component: () => import('@/pages/Home/InfoRef8.vue')  },
          { path: 'InfoRef9', component: () => import('@/pages/Home/InfoRef9.vue')  },
          { path: 'InfoPrice', component: () => import('@/pages/Home/InfoPrice.vue') },
          { path: 'InfoBlog', component: () => import('@/pages/Home/InfoBlog.vue')  },
          { path: 'BaroJoin', component: () => import('@/pages/Home/BaroJoin.vue')  },
          { path: 'BaroLogin', component: () => import('@/pages/Home/BaroLogin.vue')  },
          { path: "Contact", component: () => import('@/pages/Home/Contact.vue') },
          { path: 'TermsService', component: () => import('@/pages/Home/TermsService.vue') },
          { path: 'PrivacyPolicy', component: () => import('@/pages/Home/PrivacyPolicy.vue') },
          { path: 'RefundPolicy', component: () => import('@/pages/Home/RefundPolicy.vue') },
        ]
      } 
    
    //관리자
    , {
        path: '/Admin',
        component: () => import('@/pages/Admin/Admin.vue'), 
        redirect: "/Admin/AccntList",
        children:[

          //관리자 기본 메뉴
          { path : "AccntList", component: () => import('@/pages/Admin/AccntList.vue') },
          { path : "NoticeList", component: () => import('@/pages/Admin/NoticeList.vue') },
          { path : "NoticeDetail", component: () => import('@/pages/Admin/NoticeDetail.vue') },
          { path : "NoticeDetail/:code", component: () => import('@/pages/Admin/NoticeDetail.vue') },
          { path : "ManualList", component: () => import('@/pages/Admin/ManualList.vue') },
          { path : "ManualDetail", component: () => import('@/pages/Admin/ManualDetail.vue') },
          { path : "ManualDetail/:code", component: () => import('@/pages/Admin/ManualDetail.vue') },
          { path : "SubAccntList", component: () => import('@/pages/Common/SubAccntList.vue') },
          { path : "ContentTypeList", component: () => import('@/pages/Admin/ContentTypeList.vue') },
          { path : "SubscriptList", component: () => import('@/pages/Admin/SubscriptList.vue') },
          { path : "ReviewShopList", component: () => import('@/pages/Admin/ReviewShopList.vue') },
          { path : "ReviewShopDetail/:localid", component: () => import('@/pages/Admin/ReviewShopDetail.vue') },
          { path : "ReviewShopImageList/:localid", component: () => import('@/pages/Admin/ReviewShopImageList.vue') },
          { path : "Report", component: () => import('@/pages/Admin/Report.vue') },
          { path : "MyPayment", component: () => import('@/pages/My/MyPayment.vue') },

          //리소스 관리
          { path : "ContentList", component: () => import('@/pages/Admin/ContentList.vue') },
          { path : "PopupList", component: () => import('@/pages/Admin/PopupList.vue') },
          { path : "ContentDeleteList", component: () => import('@/pages/Admin/ContentDeleteList.vue') },
          { path : "AssetList", component: () => import('@/pages/Admin/AssetList.vue') },
          { path : "ResImgList", component: () => import('@/pages/Admin/ResImgList.vue') },
          { path : "ResMvList", component: () => import('@/pages/Admin/ResMvList.vue') },
          { path : "FontList", component: () => import('@/pages/Admin/FontList.vue') },
          { path : "EditAni", component: () => import('@/pages/Admin/EditAni.vue') },
          { path : "ResMaskList", component: () => import('@/pages/Admin/ResMaskList.vue') },
          { path : "CutEditor", component: () => import('@/pages/Admin/CutEditor.vue') },
          { path : "SetPageList", component: () => import('@/pages/Common/SetPageList.vue') },
          { path : "PageTemplateList", component: () => import('@/pages/Admin/PageTemplateList.vue') },

          //사용자 메뉴
          { path : "MyPage", component: () => import('@/pages/My/MyPage.vue') },
          { path : "MyDevice", component: () => import('@/pages/My/MyDevice.vue') },
          { path : "MyContent", component: () => import('@/pages/My/MyContent.vue') },
          { path : "MyContentDelete", component: () => import('@/pages/My/MyContentDelete.vue') },
          { path : "MyContentGroup", component: () => import('@/pages/My/MyContentGroup.vue') },
          { path : "MyContentGroupDetail", component: () => import('@/pages/My/MyContentGroupDetail.vue') },
          { path : "MySchedule", component: () => import('@/pages/My/MySchedule.vue') },
          { path : "MyScheduleDetail", component: () => import('@/pages/My/MyScheduleDetail.vue') },
          { path : "MyResource", component: () => import('@/pages/My/MyResource.vue') },
          { path : "MyResourceData", component: () => import('@/pages/My/MyResourceData.vue') },
          { path : "MyResourceDetail", component: () => import('@/pages/My/MyResourceDetail.vue') },
          { path : "MultiResource", component: () => import('@/pages/My/MultiResource.vue') },
          { path : "RtBoardManage", component: () => import('@/pages/My/RtBoardManage.vue') },
          { path : "MyPayment", component: () => import('@/pages/My/MyPayment.vue') },

          { path : "SetPageList", component: () => import('@/pages/Common/SetPageList.vue') },
          { path : "PageDetail", component: () => import('@/pages/Common/PageDetail.vue') },
          { path : "SubAccntList", component: () => import('@/pages/Common/SubAccntList.vue') },

          //사용자 유도 편의 기능
          { path : "SelectContentType", component: () => import('@/pages/My/SelectContentType.vue') },
          { path : "SelectContent", component: () => import('@/pages/My/SelectContent.vue') },
          { path : "SelectContentCompany", component: () => import('@/pages/My/SelectContentCompany.vue') },

          
        ]
    }

    //My
    , {
        path: '/My',
        component: () => import('@/pages/My/My.vue'), 
        redirect: "/My/MyContent",
        children:[
          { path : "MyPage", component: () => import('@/pages/My/MyPage.vue') },
          { path : "MyDevice", component: () => import('@/pages/My/MyDevice.vue') },
          { path : "MyContent", component: () => import('@/pages/My/MyContent.vue') },
          { path : "MyContentDelete", component: () => import('@/pages/My/MyContentDelete.vue') },
          { path : "MyContentGroup", component: () => import('@/pages/My/MyContentGroup.vue') },
          { path : "MyContentGroupDetail", component: () => import('@/pages/My/MyContentGroupDetail.vue') },
          { path : "MySchedule", component: () => import('@/pages/My/MySchedule.vue') },
          { path : "MyScheduleDetail", component: () => import('@/pages/My/MyScheduleDetail.vue') },
          { path : "MyResource", component: () => import('@/pages/My/MyResource.vue') },
          { path : "MyResourceData", component: () => import('@/pages/My/MyResourceData.vue') },
          { path : "MyResourceDetail", component: () => import('@/pages/My/MyResourceDetail.vue') },
          { path : "MultiResource", component: () => import('@/pages/My/MultiResource.vue') },
          { path : "RtBoardManage", component: () => import('@/pages/My/RtBoardManage.vue') },
          { path : "MyPayment", component: () => import('@/pages/My/MyPayment.vue') },

          { path : "SetPageList", component: () => import('@/pages/Common/SetPageList.vue') },
          { path : "PageDetail", component: () => import('@/pages/Common/PageDetail.vue') },
          { path : "SubAccntList", component: () => import('@/pages/Common/SubAccntList.vue') },

          //사용자 유도 편의 기능
          { path : "SelectContentType", component: () => import('@/pages/My/SelectContentType.vue') },
          { path : "SelectContent", component: () => import('@/pages/My/SelectContent.vue') },
          { path : "SelectContentCompany", component: () => import('@/pages/My/SelectContentCompany.vue') },
        ]
    }

    //Mobile
    , {
        path: '/Mobile',
        component: () => import('@/pages/Mobile/MobileHome.vue')
    }
    , {
        path: '/Mobile/MyPage',
        component: () => import('@/pages/Mobile/MobileMyPage.vue')
    }
    , {
        path: '/Mobile/MyPayment',
        component: () => import('@/pages/Mobile/MobilePayment.vue')
    }
    , {
        path: '/Mobile/MyDevice',
        component: () => import('@/pages/Mobile/MobileDevice.vue')
    }
    , {
        path: '/Mobile/MyResource',
        component: () => import('@/pages/Mobile/MobileResource.vue')
    }
    , {
        path: '/Mobile/MyResourceData',
        component: () => import('@/pages/Mobile/MobileResourceData.vue')
    }
    , {
        path: '/Mobile/MyGroup',
        component: () => import('@/pages/Mobile/MobileGroup.vue')
    }
    , {
        path: '/Mobile/MyGroupDetail',
        component: () => import('@/pages/Mobile/MobileGroupDetail.vue')
    }
    , {
        path: '/Mobile/MySchedule',
        component: () => import('@/pages/Mobile/MobileSchedule.vue')
    }
    , {
        path: '/Mobile/MyScheduleDetail',
        component: () => import('@/pages/Mobile/MobileScheduleDetail.vue')
    }
    , {
        path: '/Mobile/MyReport',
        component: () => import('@/pages/Mobile/MobileReport.vue')
    }
    , {
        path: '/Mobile/MultiResource',
        component: () => import('@/pages/Mobile/MobileMultiResource.vue')
    }
    , {
        path: '/Mobile/RtBoardManage',
        component: () => import('@/pages/Mobile/MobileRtBoardManage.vue')
    }

    //공통
    , {path : "/ServiceAgree", component: () => import('@/pages/ServiceAgree.vue') }
    , {path : "/SubLogin",      component: () => import('@/pages/SubLogin.vue') }
    
    , {path : "/EditContent",   component: () => import('@/pages/EditContent.vue')}
    , {path : "/EditContent/:type/:idx",   component: () => import('@/pages/EditContent.vue')}

    , {path : "/Player",            component:Player}
    , {path : "/ContentPlay",       component:ContentPlay}
    

    //테스트
    , {path : "/EditViewer",        component: () => import('@/pages/Test/EditViewer.vue')}
    , {path : "/HelloWorld",        component: () => import('@/pages/Test/HelloWorld.vue')}
    , {path : "/Fablic",            component: () => import('@/pages/Test/Fablic.vue')}
    , {path : "/GroupTest",         component: () => import('@/pages/Test/GroupTest.vue')}
    , {path : "/SaveLoad",          component: () => import('@/pages/Test/SaveLoad.vue')}
    , {path : "/Test",              component: () => import('@/pages/Test/Test.vue')}
    //, {path : "/TestUndo",              component: () => import('@/pages/Test/TestUndo.vue')}
    , {path : "/DragDrop",          component: () => import('@/pages/Test/DragDrop.vue')}
    , {path : "/EditWindowTest",    component: () => import('@/pages/Test/EditWindowTest.vue')}
    , {path : "/EditWindowFab",     component: () => import('@/pages/Test/EditWindowFab.vue')}
    , {path : "/EditContentFab",    component: () => import('@/pages/Test/EditContentFab.vue')}
    , {path : "/EditWindowFixed",   component: () => import('@/pages/Test/EditWindowFixed.vue')}
    , {path : "/EditWindowScroll",  component: () => import('@/pages/Test/EditWindowScroll.vue')}

    //예외
    , {path : "/:pathMatch(.*)*", redirect:"/404"}
    , {path : "/404",           component: () => import('@/pages/NotFound.vue') }    

]

const router = createRouter({
    history: createWebHistory(),
    routes
});

// GTM 전환 트래킹 - 회원가입 진입(회원가입 버튼 클릭) 신호
// 모든 가입 버튼이 '/Home/BaroJoin'으로 이동하므로 한 곳에서 일괄 추적
router.afterEach((to) => {
    if (to.path === '/Home/BaroJoin') {
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({ 'event': 'sign_up_click' });
    }

    // SEO - 라우트별 title/description/canonical/og 갱신 (매핑은 utils/seo.ts)
    applySeo(to.path);
});

// 배포 후 옛 화면(탭)에서 이동 시 청크 로딩 실패 → 해당 경로로 새로고침해서 새 빌드를 받는다.
// (빌드마다 청크 파일명이 바뀌므로, 배포 전부터 열려 있던 탭은 옛 파일을 찾다가 실패할 수 있음)
// 10초 안에 다시 실패하면 무한 새로고침을 막기 위해 그대로 둔다.
router.onError((error, to) => {
    const msg = String(error?.message || error);
    const isChunkError = error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk .+ failed/i.test(msg);
    if (!isChunkError) return;

    const key = 'chunk_reload_at';
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last < 10000) return;
    sessionStorage.setItem(key, String(Date.now()));
    window.location.assign(to.fullPath);
});

export default router;